import auth from '@/util/auth'

export default {
  data(){
    return {
      page:{}
    }
  },
  created(){
    let page = Object.assign(this.page || {} , {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pageSizeOpts:[10,20,30,40]
    })

    this.page = {
      ...page,
      current:page.pageNum,
      size:"small",
      showSizeChanger:true,
      showQuickJumper:true,
      showTotal:total => `共 ${total} 条`,
    }
    if(!this.$a){
      this.$a = auth.hasAuthority(name)
    }
  },
  methods:{
    reset(){
      
    },
    // $a(name){
    //   return auth.hasAuthority(name)
    // },
    $tableChange(pagination, filters, sorter){
      let flag = false
      if(this.page.current != pagination.current){
        this.page.pageNum = this.page.current = pagination.current
        flag = true
      }

      if(this.page.pageSize != pagination.pageSize){
        this.page.pageSize = pagination.pageSize
        flag = true
      }

      if(flag){
        if(this.search) this.search()
      }
    }
  }
}